import { DataValidator, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api, { apiService } from "./api";

export interface TiktokWebAuthorizeUrlResponse {
  authorize_url: string;
}

class TiktokWebAuthorizeUrlData {
  @Required("Authorize url cannot be empty")
  @IsString("Authorize url must be a string")
  authorizeUrl: string;
}

const transformAndValidateData = (
  response: TiktokWebAuthorizeUrlResponse
): TiktokWebAuthorizeUrlData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, TiktokWebAuthorizeUrlData);
  } catch (error) {
    console.error("Tiktok web authorize url data validation failed:", error.message);
    throw error;
  }
};

// TikTok 授权
export const tiktokWebAuthorizeUrl = async (redirectUri: string) => {
  const res = await api.post<TiktokWebAuthorizeUrlResponse>('/tiktok/web/authorize-url', {
    frontend_redirect_uri: redirectUri,
  });
  return transformAndValidateData(res.data);
};
